<template>
  <div ref="desktop-top" class="sky__desktop-top">
    <div v-if="isCheckout" class="container mx-auto text-white py-2 text-xs flex justify-between items-center">
      <a :href="$route.path === '/transaction' ? '/commande' : '/'" class="flex items-center text-white hover:text-white" style="width: 160px">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-1"><polyline points="15 18 9 12 15 6"></polyline></svg>
        Retour
      </a>
      <a href="/" class="flex">
        <icon-logo style="width: 60px; height: 40px; filter: brightness(0) invert(1);" />
      </a>
      <div class="flex items-center justify-end" style="width: 160px">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-1"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
        Paiement sécurisé
      </div>
    </div>
    <div v-else class="container mx-auto text-white py-2 text-xs flex justify-between">
      <div>
        Besoin d'un conseil? Appelez-nous au +33 (0)3 66 72 85 22
      </div>
      <div v-if="configuration.general_offer">
        <span v-html="transformedBanner"></span>
      </div>
      <div>
        Livraison gratuite en point relais dès 99 € hors commande volumineuse
        <span v-if="$store.getters['auth/isLoggedIn']">
          - Bonjour <nuxt-link to="/mon-compte">{{ $store.state.auth.displayName }}</nuxt-link>
          - <a href="#" class="underline" @click.prevent="$store.dispatch('auth/disconnect')">Déconnexion</a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { marked } from 'marked'
export default {
  props: {
    configuration: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      banner: null
    }
  },
  computed: {
    isCheckout () {
      return this.$route.path === '/transaction' || this.$route.path === '/commande'
    },
    transformedBanner () {
      if (!this.configuration?.general_offer) {
        return null
      }
      return marked(this.configuration.general_offer)
    }
  }
}
</script>

<style lang="scss" scoped>
  .sky__desktop-top {
    @apply bg-sky_blue hidden;
    @screen lg {
      @apply block;
    }
  }
</style>
